import i18next from 'i18next';
import Backend from 'i18next-http-backend';

export function initI18Next(namespaces) {
    let userLang = document.documentElement.lang;
    userLang = userLang.toLowerCase();
    if (!Array.isArray(namespaces)) {
        namespaces = [namespaces];
    }

    return i18next
        .use(Backend)
        .init({
            lng: userLang,
            fallbackLng: 'en',
            debug: process.env.NODE_ENV !== 'production',
            ns: namespaces,
            defaultNS: namespaces[0],
            interpolation: {
                escapeValue: false
            },
            compatibilityJSON: 'v4',
            backend: {  // Configuration for i18next-http-backend
                loadPath: '/static/locales/{{lng}}/{{ns}}.json',
                crossDomain: true // Set this to true if you are loading translations from another domain.
            }
        });
}


export function loadNamespaces(namespaces) {
    if (!Array.isArray(namespaces)) {
        namespaces = [namespaces];
    }
    // Загружаем все NS, не проверяя их текущее состояние
    return i18next.loadNamespaces(namespaces);
}